import React from 'react'
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'

interface DateRangePickerProps {
  value: number // days
  onChange: (days: number) => void
  options?: { label: string; value: number }[]
}

const defaultOptions = [
  { label: '7 dage', value: 7 },
  { label: '14 dage', value: 14 },
  { label: '30 dage', value: 30 },
  { label: '90 dage', value: 90 },
]

export default function DateRangePicker({
  value,
  onChange,
  options = defaultOptions,
}: DateRangePickerProps) {
  const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: number | null) => {
    if (newValue !== null) {
      onChange(newValue)
    }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
        Periode:
      </Typography>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{
          '& .MuiToggleButton-root': {
            px: 2,
            py: 0.75,
            border: '1px solid',
            borderColor: 'divider',
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.8rem',
            '&.Mui-selected': {
              backgroundColor: 'primary.main',
              color: 'white',
              borderColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            },
          },
        }}
      >
        {options.map((option) => (
          <ToggleButton key={option.value} value={option.value}>
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  )
}
